/**
 * Engagement attachment schemas.
 *
 * Attachments are files linked to an engagement. The actual file storage
 * is handled outside the DB; we only store metadata (URL, size, MIME type).
 */

import { z } from "zod";
import { idSchema, iso8601Schema } from "./common";

export const engagementAttachmentOutputSchema = z.object({
  id: idSchema,
  engagementId: idSchema,
  uploadedById: idSchema,
  fileName: z.string().min(1).max(255),
  fileUrl: z.string().url().max(2048),
  fileSize: z.number().int().nonnegative(),
  mimeType: z.string().max(128).nullable(),
  uploadedAt: iso8601Schema,
  deletedAt: iso8601Schema.nullable(),
});
export type EngagementAttachmentOutput = z.infer<typeof engagementAttachmentOutputSchema>;

export const createEngagementAttachmentInputSchema = z.object({
  fileName: z.string().min(1).max(255),
  fileUrl: z.string().url().max(2048),
  fileSize: z.number().int().nonnegative(),
  mimeType: z.string().max(128).nullable().optional(),
});
export type CreateEngagementAttachmentInput = z.infer<typeof createEngagementAttachmentInputSchema>;
